import { render, staticRenderFns } from "./ModifyOrderStatusBulk.vue?vue&type=template&id=60fc2dda&scoped=true"
import script from "./ModifyOrderStatusBulk.vue?vue&type=script&lang=ts"
export * from "./ModifyOrderStatusBulk.vue?vue&type=script&lang=ts"
import style0 from "./ModifyOrderStatusBulk.vue?vue&type=style&index=0&id=60fc2dda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fc2dda",
  null
  
)

export default component.exports